import {Controller} from "@hotwired/stimulus"
import {Loggable} from "./concerns/loggable"
import * as bootstrap from "bootstrap"

// Usage:
// <button type="button" data-controller="popover" class="btn btn-lg btn-danger" data-bs-toggle="popover" data-bs-title="Popover title" data-bs-content="And here's some amazing content. It's very engaging. Right?">Click to toggle popover</button>
export default class extends Controller {

  initialize() {
    Loggable(this, {debug: false})
  }

  connect() {
    this.popover = new bootstrap.Popover(this.element, {
      html: true,
      popperConfig: (config) => ({
        ...config,
        modifiers: [...config.modifiers, {
          name: "preventOverflow",
          options: {altAxis: true, tether: false, padding: 8}
        }]
      }),
    })

    // Add click event listener to the document body
    // To close the popover when clicking outside of it
    this.hideOnOutsideClick = (event) => {
      this.log("hiding")
      if (!this.element.contains(event.target)) {
        this.popover.hide()
      }
    }
    this.hideOnHistoryRestore = () => this.popover.hide()
    document.body.addEventListener('click', this.hideOnOutsideClick)
    window.addEventListener('schedule-days:restore', this.hideOnHistoryRestore)
    this.log("connected")
  }

  disconnect() {
    document.body.removeEventListener('click', this.hideOnOutsideClick)
    window.removeEventListener('schedule-days:restore', this.hideOnHistoryRestore)
    this.popover.dispose()
  }

  show(event) {
    event.preventDefault()
    this.popover.show()
    this.log("show")
  }
}
